export default __webpack_public_path__ + "img/d82b6361ecd228d3752edb62daa21d74.svg";